{
  "title": "Unbekanntes Flugzeug zuordnen",
  "description": "Flugzeuge, die während der FlightBridge-Synchronisierung nicht zugeordnet werden konnten. Wähle einen Flugzeugtyp aus, um einen Mandanten zu erstellen. Ein Administrator wird die FAA-Zuordnung später prüfen und genehmigen.",
  "alerts": {
    "noActiveFBO": "Kein aktives FBO ausgewählt",
    "noPendingAircraft": "Keine ausstehenden Flugzeuge – alle synchronisierten Flugzeuge wurden zugeordnet!"
  },
  "toolbar": {
    "refresh": "Neu laden",
    "pendingCount": "Ausstehend"
  },
  "table": {
    "headers": {
      "tailNumber": "Kennzeichen",
      "typeHint": "Typhinweis",
      "operator": "Betreiber",
      "mapToAircraft": "Flugzeug zuordnen",
      "created": "Erstellt"
    },
    "empty": "Keine ausstehenden Flugzeuge",
    "processing": "Erstelle Mandant...",
    "selectAircraft": "Flugzeug auswählen"
  },
  "messages": {
    "userNotAuthenticated": "Nicht angemeldet",
    "mappingFailed": "Flugzeugzuordnung fehlgeschlagen"
  },
  "fallbacks": {
    "unknownOperator": "Unbekannt",
    "unknownType": "Unbekannt"
  }
}
